import { inject, Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { KovanTaskModel } from 'ui-shared';
import { BpmnStageListComponent } from 'infrastructure-shared';
import { Router } from '@angular/router';


@Injectable({
    providedIn: 'root',
})
export class ApprovableDataService {

    protected dialogService = inject(DialogService);
    protected translateService = inject(TranslateService);
    protected router = inject(Router);

    getTaskItemFromRoute(): KovanTaskModel {
        let navigation = this.router.getCurrentNavigation();
        if (navigation == null) {
            navigation = this.router.lastSuccessfulNavigation;
        }
        return navigation?.extras?.state?.taskItem;
    }

    openBPMNHistory(businessKey: string, processDefinitionKey: string) {
        this.dialogService.open(BpmnStageListComponent, {
            width: '80%',
            data: {
                businessKey: businessKey,
                processDefinitionKey: processDefinitionKey,
            },
            header: this.translateService.instant('bpmnStage.pageHeader'),
            contentStyle: { 'max-height': '600px', overflow: 'auto' },
        });
    }
}
